import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  fr: {
    nav_history: "Histoire",
    nav_peoples: "Peuples",
    nav_timeline: "Chronologie",
    nav_figures: "Figures",
    nav_culture: "Culture",
    nav_tales: "Contes",
    nav_youth: "Jeunesse",
    nav_langues: "Langues",
    nav_home: "Accueil",
    nav_videos: "Vidéos",
    nav_org: "Organigramme",
    nav_community: "Communauté",
    pwa_title: "Installer ANYANG BETI",
    pwa_text: "Ajoutez le portail à votre écran d'accueil pour un accès rapide, même hors ligne.",
    pwa_install: "Installer",
    pwa_dismiss: "Fermer",
    nav_manifeste: "Manifeste",
    nav_bibliography: "Bibliographie",
    nav_frise: "Frise chronologique",
    nav_missmister: "Miss & Mister",
    nav_donate: "Faire un don",
    nav_projects: "Projets",
    nav_events: "Événements",
    nav_galleries: "Galeries",
    nav_map: "Carte",
    nav_tree: "Ramifications",
    nav_about: "À propos",
    nav_member: "Espace membre",
    nav_admin: "Administration",
    nav_join: "Devenir membre",
    nav_login: "Connexion",
    nav_logout: "Déconnexion",
    signature: "Notre culture, notre force. Notre unité, notre richesse.",
    devise: "Unité • Rapprochement • Solidarité • Développement",
    subtitle: "Portail mondial de l'histoire, de la mémoire et du patrimoine du peuple Beti",
    hero_enter: "Le portail de l'histoire et du patrimoine du peuple Beti",
    door_history: "Explorer notre histoire",
    door_history_sub: "Chronologie, migrations, résistances et figures emblématiques",
    door_peoples: "Découvrir nos peuples",
    door_peoples_sub: "Groupes, ramifications, territoires, langues et traditions",
    door_memory: "Écouter notre mémoire",
    door_memory_sub: "Contes, témoignages, proverbes, chants et archives sonores",
    door_future: "Bâtir notre avenir",
    door_future_sub: "Anyang Beti, adhésions, bourse scolaire et projets solidaires",
    explore: "Explorer",
    read_more: "Lire la suite",
    discover: "Découvrir",
    learn_more: "En savoir plus",
    all: "Tout voir",
    back: "Retour",
    prev: "Précédent",
    next: "Suivant",
    sources: "Sources et références",
    contribute: "Proposer une correction / contribution",
    loading: "Chargement…",
    members: "Membres",
    peoples_count: "Peuples documentés",
    tales_count: "Contes & récits",
    projects_count: "Projets communautaires",
    figures_count: "Figures",
    join_cta_title: "Rejoignez la mémoire vivante",
    join_cta_text: "Devenez membre d'Anyang Beti et participez à la préservation et à la transmission du patrimoine Beti.",
    disclaimer_oral: "Ce récit relève de la tradition orale. Il possède une grande valeur mémorielle sans constituer une preuve scientifique absolue.",
  },
  en: {
    nav_history: "History",
    nav_peoples: "Peoples",
    nav_timeline: "Timeline",
    nav_figures: "Figures",
    nav_culture: "Culture",
    nav_tales: "Tales",
    nav_youth: "Youth",
    nav_langues: "Languages",
    nav_home: "Home",
    nav_videos: "Videos",
    nav_org: "Org chart",
    nav_community: "Community",
    pwa_title: "Install ANYANG BETI",
    pwa_text: "Add the portal to your home screen for quick access, even offline.",
    pwa_install: "Install",
    pwa_dismiss: "Close",
    nav_manifeste: "Manifesto",
    nav_bibliography: "Bibliography",
    nav_frise: "Timeline",
    nav_missmister: "Miss & Mister",
    nav_donate: "Donate",
    nav_projects: "Projects",
    nav_events: "Events",
    nav_galleries: "Galleries",
    nav_map: "Map",
    nav_tree: "Ramifications",
    nav_about: "About",
    nav_member: "Member area",
    nav_admin: "Administration",
    nav_join: "Become a member",
    nav_login: "Sign in",
    nav_logout: "Sign out",
    signature: "Our culture, our strength. Our unity, our wealth.",
    devise: "Unity • Togetherness • Solidarity • Development",
    subtitle: "World portal of the history, memory and heritage of the Beti people",
    hero_enter: "The portal of the history and heritage of the Beti people",
    door_history: "Explore our history",
    door_history_sub: "Timeline, migrations, resistance and emblematic figures",
    door_peoples: "Discover our peoples",
    door_peoples_sub: "Groups, ramifications, territories, languages and traditions",
    door_memory: "Listen to our memory",
    door_memory_sub: "Tales, testimonies, proverbs, songs and sound archives",
    door_future: "Build our future",
    door_future_sub: "Anyang Beti, membership, scholarships and solidarity projects",
    explore: "Explore",
    read_more: "Read more",
    discover: "Discover",
    learn_more: "Learn more",
    all: "View all",
    back: "Back",
    prev: "Previous",
    next: "Next",
    sources: "Sources and references",
    contribute: "Propose a correction / contribution",
    loading: "Loading…",
    members: "Members",
    peoples_count: "Documented peoples",
    tales_count: "Tales & accounts",
    projects_count: "Community projects",
    figures_count: "Figures",
    join_cta_title: "Join the living memory",
    join_cta_text: "Become a member of Anyang Beti and take part in preserving and transmitting Beti heritage.",
    disclaimer_oral: "This account belongs to oral tradition. It holds great mnemonic value without being absolute scientific proof.",
  },
};

const LangContext = createContext(null);

const safeGet = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const safeSet = (k, v) => { try { localStorage.setItem(k, v); } catch { /* ignore */ } };

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(safeGet("ab_lang") || "fr");
  const toggle = useCallback(() => {
    setLang((l) => {
      const nl = l === "fr" ? "en" : "fr";
      safeSet("ab_lang", nl);
      return nl;
    });
  }, []);
  const t = useCallback((key) => dict[lang][key] || key, [lang]);
  const tr = useCallback((obj) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] || obj.fr || obj.en || "";
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t, tr }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
